import styled from 'styled-components';

export const StyledTerms = styled.div`
  text-align: center;
  margin: 50px 0 0;
  padding: 0 100px;
  line-height: 1.4;
  font-size: ${props => props.theme.fontSizes.extraSmall};
  color: #999;
`
